export default __webpack_public_path__ + "static/media/services.dc5e6b35.svg";